// С какого уровня враг доступен в процедурной генерации обычных волн.
// kangaroo_joey НЕ в таблице — он спавнится только через spawnsOnDeath кенгуру,
// не напрямую генератором.
export interface EnemyUnlock {
  enemyId: string;
  unlockedFromLevel: number;
}

// Структурная пересборка W2: пороги привязаны к новым боссам (каждые 5 уровней).
// Mouse сдвинут с L1 на L11 — мыши мелкие, нужно скорострельное оружие
// (assault_rifle открывается после boarling_wave на L10). До L5 только rabbit.
export const ENEMY_UNLOCKS: EnemyUnlock[] = [
  { enemyId: 'rabbit', unlockedFromLevel: 1 }, // единственный до big_boar (L5)
  { enemyId: 'boarling', unlockedFromLevel: 6 }, // после big_boar (L5)
  { enemyId: 'mouse', unlockedFromLevel: 11 }, // после boarling_wave (L10) + assault_rifle
  { enemyId: 'fox', unlockedFromLevel: 16 }, // после fox_wave (L15)
  { enemyId: 'beetle', unlockedFromLevel: 18 }, // середина эры
  { enemyId: 'deer', unlockedFromLevel: 21 }, // после deer_wave (L20)
  { enemyId: 'kangaroo', unlockedFromLevel: 26 }, // после elk (L25)
  { enemyId: 'wolf', unlockedFromLevel: 36 }, // после wolf_wave (L35)
];

export function getAvailableEnemies(level: number): string[] {
  return ENEMY_UNLOCKS.filter((u) => level >= u.unlockedFromLevel).map((u) => u.enemyId);
}
